import {FC} from 'react'
import {DemosToggleDrawer} from './demos-drawer/DemosToggleDrawer'
import { VersionsToggleDrawer } from './version-drawer/VersionsToggleDrawer'
import {ToggleHelpDrawer} from './help-drawer/ToggleHelpDrawer'
import {DemosDrawer} from './demos-drawer/DemosDrawer'
import {HelpDrawer} from './help-drawer/HelpDrawer'
import {PurchaseButton} from './purchase/PurchaseButton'
import { VersionDrawer } from './version-drawer/VersionsDrawer'

const RightToolbar: FC = () => {
  return (
    <>
      <div className='engage-toolbar d-flex position-fixed px-5 fw-bolder zindex-2 top-50 end-0 transform-90 mt-20 gap-2'>
        <DemosToggleDrawer />
        <VersionsToggleDrawer />
        <ToggleHelpDrawer />
        <PurchaseButton />
      </div>

      <VersionDrawer/>
      <DemosDrawer />
      <HelpDrawer />
    </>
  )
}

export {RightToolbar}
